import React from 'react';
import {
  Menu,
  MenuTrigger,
  MenuPopover,
  MenuList,
  MenuItem,
} from '@fluentui/react-components';
import {
  Delete20Regular,
  Edit20Regular,
  MoreHorizontal20Regular,
} from '@fluentui/react-icons';

/**
 * Composant label pour le nœud Transfer (User ou Phone)
 * Accepte soit routing/routingKey (routing normal) soit optionData (nœud terminal)
 */
const TransferNodeLabel = ({ routingKey, routing, optionData, handleEditNode, handleDeleteNode }) => {
  // Si c'est un nœud terminal (optionData existe)
  if (optionData) {
    const targetType = optionData.targetType || 'user';
    const isUser = targetType === 'user';
    const isPhone = targetType === 'phone';
    const nodeId = isPhone ? `transfer-pstn-${optionData.targetId}` : `transfer-user-${optionData.targetId}`;
    
    const displayName = isUser 
      ? (optionData.displayName || optionData.userDisplayName || 'Not configured')
      : (optionData.targetId || 'Not configured');
    
    const icon = isUser ? '' : '';
    const title = isUser ? 'Transfer to User' : 'Transfer to Phone';

    return (
      <div className={`node-${isUser ? 'user' : 'phone'}`}>
        <Menu>
          <MenuTrigger disableButtonEnhancement>
            <button
              className="node-menu-btn"
              onClick={(e) => e.stopPropagation()}
              title="Options"
            >
              <MoreHorizontal20Regular />
            </button>
          </MenuTrigger>
          <MenuPopover>
            <MenuList>
              <MenuItem
                icon={<Delete20Regular />}
                onClick={(e) => {
                  e.stopPropagation();
                  handleDeleteNode(nodeId);
                }}
              >
                Supprimer
              </MenuItem>
            </MenuList>
          </MenuPopover>
        </Menu>
        <div className="node-title">{icon} {title}</div>
        <div className="node-separator"></div>
        <div className="node-info">
          <div className="node-info-item" style={{ fontWeight: 600 }}>{displayName}</div>
        </div>
      </div>
    );
  }
  
  // Sinon, c'est un routing normal
  const routingId = `routing-${routingKey}`;
  const routingDisplayName = routingKey === '0' ? 'Start' : (routing?.displayName || routing?.routingName || routingKey);
  const targetType = routing?.targetType || 'user';
  const isUser = targetType === 'user';
  const isPhone = targetType === 'phone';
  const isDefaultRouting = routingKey === '0';
  
  const targetDisplayName = isUser 
    ? (routing?.userDisplayName || 'Not configured')
    : (routing?.targetId || 'Not configured');
  
  const transferType = isUser ? 'Transfer to User' : 'Transfer to Phone';

  return (
    <div className={`node-${isUser ? 'user' : 'phone'}`}>
      <Menu>
        <MenuTrigger disableButtonEnhancement>
          <button
            className="node-menu-btn"
            onClick={(e) => e.stopPropagation()}
            title="Options"
          >
            <MoreHorizontal20Regular />
          </button>
        </MenuTrigger>
        <MenuPopover>
          <MenuList>
            <MenuItem
              icon={<Edit20Regular />}
              onClick={(e) => {
                e.stopPropagation();
                handleEditNode(routingId);
              }}
            >
              Éditer
            </MenuItem>
            {!isDefaultRouting && (
              <MenuItem
                icon={<Delete20Regular />}
                onClick={(e) => {
                  e.stopPropagation();
                  handleDeleteNode(routingId);
                }}
              >
                Supprimer
              </MenuItem>
            )}
          </MenuList>
        </MenuPopover>
      </Menu>
      <div className="node-title">{routingDisplayName}</div>
      <div className="node-separator"></div>
      <div className="node-info">
        <div className="node-info-item">{transferType}</div>
        <div className="node-info-item" style={{ fontWeight: 600 }}>{targetDisplayName}</div>
      </div>
    </div>
  );
};

export default TransferNodeLabel;
